import React from "react";
import { Button, OverlayTrigger, ProgressBar, Tooltip } from "react-bootstrap";
import SmsCounter from "../../../../loneworker/utils/SmsCounter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

export default function SMSCounter({ text }) {
  const count = SmsCounter.count(text);

  return (
    <div>
      <div className="fw-bold text-purple text-center my-1">
        {count.sms_chars_remaining} chars remaining{" "}
        <span className="p-1 rounded-pill bg-purple-gradient">
          {count.sms_message_count}
        </span>
        SMS
      </div>
      <div className="d-flex justify-content-center gap-2 small text-secondary fw-bold align-items-center">
        <div>Encoding: {count.encoding}</div> |
        <div>Chars per SMS: {count.per_message} </div>
        {count.encoding !== "GSM_7BIT" && (
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={
              <Tooltip id="tooltip">
                This message contains non-GSM characters, which will be encoded
                in {count.encoding} format. This will reduce the number of
                characters that can be sent in a single SMS.
              </Tooltip>
            }
          >
            <Button variant="link" className="link-danger p-0 m-0 ms-2">
              <FontAwesomeIcon icon={faTriangleExclamation} size="sm" />
            </Button>
          </OverlayTrigger>
        )}
      </div>
      <div
        className="progress my-2 bg-purple-gradient-darker"
        style={{ height: 5 }}
      >
        <div
          className="progres-bar bg-colored "
          style={{ width: `${count.percent}%` }}
        />
      </div>
    </div>
  );
}
